export default function PlatformPrivacyPolicyContent() {
  return (
    <article className="space-y-6 text-sm text-stone-700 leading-relaxed">
      <section>
        <h2 className="text-base font-semibold text-stone-900">
          POLITIQUE DE CONFIDENTIALITE - PLATEFORME RAGUIA
        </h2>
        <p className="mt-1">
          Applicable aux clients et utilisateurs de la plateforme SaaS
          <br />
          Version 1.0 - 16/04/2026
        </p>
      </section>

      <section>
        <h3 className="font-semibold text-stone-900">1. Qui sommes-nous ?</h3>
        <p className="mt-1">
          La plateforme Raguia est editee par :
          <br />
          Valentin Fiess, auto-entrepreneur
          <br />
          SIRET : (a completer)
          <br />
          Adresse : Bat A705, 69 rue Simone Veil, 34470 Perols, France
          <br />
          Contact donnees personnelles : contact@valentin-fiess.fr
        </p>
        <p className="mt-2">
          Dans le cadre de la plateforme, Raguia agit en qualite de
          sous-traitant au sens du RGPD. L&apos;entreprise cliente qui souscrit
          au service est le responsable de traitement des donnees de ses
          salaries.
        </p>
      </section>

      <section>
        <h3 className="font-semibold text-stone-900">
          2. Quelles donnees sont traitees et pourquoi ?
        </h3>
        <div className="mt-2 space-y-3">
          <p>
            <strong>2.1 Donnees des comptes clients (portail)</strong>
            <br />
            Qui est concerne : le referent ou representant de l&apos;entreprise
            cliente.
            <br />
            Donnees : identifiant de connexion (slug), mot de passe hache
            (jamais lisible), adresse email le cas echeant.
            <br />
            Pourquoi : permettre l&apos;acces securise au portail de gestion.
            <br />
            Base legale : execution du contrat de service.
          </p>
          <p>
            <strong>2.2 Donnees des utilisateurs chatbot</strong>
            <br />
            Qui est concerne : les salaries de l&apos;entreprise cliente
            autorises a utiliser le chatbot.
            <br />
            Donnees : identifiant de connexion, mot de passe hache, appartenance
            a un departement (sous-client).
            <br />
            Pourquoi : authentifier les utilisateurs et filtrer l&apos;acces aux
            documents autorises.
            <br />
            Base legale : execution du contrat de service.
          </p>
          <p>
            <strong>2.3 Documents importes</strong>
            <br />
            Qui est concerne : toute personne mentionnee dans les documents
            uploades par le Client.
            <br />
            Donnees : tout contenu des documents importes - determine
            exclusivement par le Client. Ces documents peuvent contenir des
            donnees de toute nature, y compris potentiellement des donnees
            sensibles (sante, situation financiere, donnees RH).
            <br />
            Pourquoi : alimenter la base de connaissances du chatbot et
            permettre la recherche documentaire.
            <br />
            Base legale : execution du contrat de service - sous la
            responsabilite exclusive du Client qui garantit disposer d&apos;une
            base legale valide pour les donnees qu&apos;il importe.
          </p>
          <p>
            <strong>2.4 Conversations chatbot</strong>
            <br />
            Qui est concerne : les salaries utilisant le chatbot.
            <br />
            Donnees : questions posees, reponses generees, extraits de documents
            utilises comme sources. Ces echanges peuvent contenir des donnees a
            caractere personnel selon les questions posees.
            <br />
            Pourquoi : fournir un historique de conversation a
            l&apos;utilisateur, ameliorer la qualite des reponses dans le cadre
            d&apos;une meme conversation.
            <br />
            Base legale : execution du contrat de service.
          </p>
          <p>
            <strong>2.5 Donnees techniques</strong>
            <br />
            Qui est concerne : tous les utilisateurs.
            <br />
            Donnees : adresses IP, horodatages des connexions, routes API
            appelees, codes d&apos;erreur.
            <br />
            Pourquoi : securite des systemes, detection d&apos;intrusions,
            debogage technique.
            <br />
            Base legale : interet legitime (securite des systemes
            d&apos;information).
          </p>
        </div>
      </section>

      <section>
        <h3 className="font-semibold text-stone-900">
          3. Combien de temps conservons-nous vos donnees ?
        </h3>
        <ul className="mt-2 list-disc pl-5 space-y-1">
          <li>
            Comptes portail et utilisateurs chatbot : duree du contrat + 90
            jours
          </li>
          <li>Documents importes : duree du contrat + 90 jours</li>
          <li>
            Historique des conversations : 3 mois glissants (suppression
            automatique)
          </li>
          <li>Logs techniques : 7 jours maximum (rotation automatique)</li>
          <li>Sauvegardes chiffrees : 7 generations en rotation</li>
        </ul>
        <p className="mt-2">
          En cas de resiliation du contrat, les donnees sont conservees 90 jours
          pour permettre une eventuelle reactivation, puis supprimees
          definitivement. Le Client peut demander une suppression immediate sans
          attendre ce delai.
        </p>
      </section>

      <section>
        <h3 className="font-semibold text-stone-900">
          4. Qui a acces a vos donnees ?
        </h3>
        <p className="mt-1">
          <strong>4.1 En interne</strong>
          <br />
          Seul Valentin Fiess, dirigeant de Raguia, a acces aux donnees de
          production. Aucun collaborateur, prestataire ou tiers n&apos;y a acces
          sans accord prealable et ecrit du Client.
        </p>
        <p className="mt-2">
          <strong>4.2 Sous-traitants techniques</strong>
          <br />
          Pour fournir le service, Raguia fait appel aux prestataires techniques
          suivants, lies par un accord de traitement des donnees conforme au
          RGPD : OVH SAS (hebergement, France), Cloudflare Inc. (CDN,
          protection, backups, USA - CCT), Mistral AI SAS (modele de langage,
          France), OpenAI LLC (embeddings, USA - CCT), Google LLC (OCR, USA -
          CCT), Helicone Inc. (observabilite technique, USA - CCT).
        </p>
        <p className="mt-2">
          Concernant les fournisseurs americains : les transferts sont encadres
          par les Clauses Contractuelles Types (CCT) de la Commission
          Europeenne. OpenAI et Google participent au EU-US Data Privacy
          Framework. Aucun de ces fournisseurs n&apos;utilise vos donnees pour
          entrainer leurs modeles.
        </p>
        <p className="mt-2">
          Engagement de transition : Raguia s&apos;engage a migrer
          progressivement vers des fournisseurs europeens. Cette liste est mise
          a jour a chaque evolution, avec notification prealable aux clients.
        </p>
      </section>

      <section>
        <h3 className="font-semibold text-stone-900">
          5. Comment protegeons-nous vos donnees ?
        </h3>
        <p className="mt-1">
          <strong>Securite technique :</strong>
        </p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Chiffrement de toutes les communications (TLS 1.2+)</li>
          <li>
            Isolation stricte des donnees entre clients (architecture
            multi-tenant)
          </li>
          <li>Mots de passe haches (bcrypt), jamais stockes en clair</li>
          <li>Sessions securisees (cookies HttpOnly, SameSite Strict)</li>
          <li>Detection d&apos;intrusions (CrowdSec)</li>
          <li>Sauvegardes chiffrees (AES-128) avant tout stockage externe</li>
        </ul>
        <p className="mt-2">
          <strong>Securite organisationnelle :</strong>
        </p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Acces a la production limite au seul dirigeant</li>
          <li>Aucun acces tiers sans accord explicite du Client</li>
          <li>Procedure de gestion des incidents documentee</li>
        </ul>
      </section>

      <section>
        <h3 className="font-semibold text-stone-900">6. Vos droits</h3>
        <p className="mt-1">
          Les personnes concernees par les traitements (salaries du Client)
          exercent leurs droits aupres de leur employeur (le Client, responsable
          de traitement), qui repercute les demandes a Raguia.
        </p>
        <ul className="mt-2 list-disc pl-5 space-y-1">
          <li>Acces : obtenir une copie des donnees vous concernant</li>
          <li>Rectification : corriger des donnees inexactes</li>
          <li>Effacement : demander la suppression de vos donnees</li>
          <li>Limitation : demander la suspension d&apos;un traitement</li>
          <li>Portabilite : recevoir vos donnees dans un format structure</li>
          <li>
            Opposition : vous opposer a un traitement base sur l&apos;interet
            legitime
          </li>
        </ul>
        <p className="mt-2">
          Delai de reponse : Raguia s&apos;engage a repondre aux demandes
          transmises par le Client dans un delai de 5 jours ouvres.
          <br />
          Contact : contact@valentin-fiess.fr
          <br />
          Reclamation CNIL :{" "}
          <a
            href="https://www.cnil.fr"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-700 underline"
          >
            www.cnil.fr
          </a>
        </p>
      </section>

      <section>
        <h3 className="font-semibold text-stone-900">
          7. Modifications de cette politique
        </h3>
        <p className="mt-1">
          Raguia se reserve le droit de modifier la presente politique. En cas
          de modification substantielle (nouveau sous-traitant, nouvelle
          categorie de donnees), les Clients sont informes par email avec un
          preavis de 30 jours.
        </p>
        <p className="mt-2">
          La version en vigueur est toujours accessible a l&apos;adresse :
          raguia.valentin-fiess.fr/confidentialite-plateforme
        </p>
      </section>
    </article>
  );
}
